<template>
    <div v-html="standardBanner"></div>
</template>


<script>

    export default {
        name: 'standardBanner',
        data() {
            return {
                standardBanner: null
            }
        },
        mounted() {

            this.axios.get(this.$store.state.BannerNetworkHTMLCodeApi).then((response) => {
                this.standardBanner = response.data.HTMLCode;
            }).catch((error) => { })

        }
    }
</script>